import {Pipe,PipeTransform} from '@angular/core';

@Pipe({
    name:'DynamicWorkoutListBackgroundSvgPipe',
    pure:true
})

export class DynamicWorkoutListBackgroundSvgPipe implements PipeTransform {
	transform(workoutId:string):string{
        var svgImg;
		if(workoutId== 'paramIco') {
			svgImg = "Icon_Time_L";
		}else if(workoutId == '1002') {
			svgImg = "Icon_Distance_L";
		}else if(workoutId == '1003') {
			svgImg = "Icon_Calories_L";
		}else if(workoutId == '1004') {
			svgImg = "Icon_Cardio_Heartrate_L";
		}else if(workoutId == '1005' || workoutId == '1011') {
			svgImg = "Icon_Tread_Hill_1_to_1_L";
		}else if(workoutId == '1006') {
			svgImg = "Icon_Steps_L";
		}else if(workoutId == '1007' || workoutId == '1008') {
			svgImg = "Icon_Workout_L";
		}else if(workoutId == '1009' || workoutId == '1012') {
			svgImg = "Icon_Watts_L";
		}else if(workoutId == '1010') {
			svgImg = "Icon_Mets_L";
		}else if(workoutId == '1013') {
			svgImg = "Icon_Level_Resistance_L";
		}else if(workoutId == '19' || workoutId == '20' || workoutId == '7' || workoutId == '8' || workoutId == '29' || workoutId == '31'){
			svgImg = "Icon_Cardio_Interval_L";
		}else if(workoutId == '1'){
			svgImg = "Icon_Manual_L";
		}else if(workoutId == '3'){
			svgImg = "Icon_Hills_1_to_2_L";
		}else if(workoutId == '5' || workoutId == '10' || workoutId == '6' || workoutId == '16' || workoutId == '18'){
			svgImg = "Icon_Random_L";
		}else if(workoutId == '11'){
			svgImg = "Icon_Speed_Bump_L";
		}else if(workoutId == '12' || workoutId == '24' || workoutId == '32'){
			svgImg = "Icon_Rollers_2_L";	
		}else if(workoutId == '13'){
			svgImg = "Icon_Wave_L";
		}else if(workoutId == '4' || workoutId == '2'){
			svgImg = "Icon_Rollers_1_L";
		}else if(workoutId == '9'){
			svgImg = "Icon_Tread_Hill_1_to_1_L";
		}else{
			svgImg = "Icon_Time_L";
		}
        return svgImg;
    }
}